module.exports = __webpack_public_path__ + "static/media/services_background.45a683ba.jpg";